const comments = [
  {
    name: '影迷小李',
    text: '天堂影院真的太方便了，不需要注册就能直接看，画质也很清晰。下班回家追剧的首选，已经推荐给身边所有朋友了！',
    time: '3天前',
  },
  {
    name: '追剧达人阿琳',
    text: '用了好几个在线影院，天堂影院的更新速度是最快的。热门韩剧当晚就能看到中字，而且没有烦人的弹窗广告，体验满分。',
    time: '5天前',
  },
  {
    name: '电影发烧友老张',
    text: '作为一个看了二十年电影的老影迷，天堂影院的片库深度让我惊讶。很多冷门的老片子都能找到，修复版画质也相当不错。',
    time: '1周前',
  },
  {
    name: '学生党小王',
    text: '学生预算有限，天堂影院完全免费真的太良心了。周末经常跟室友一起用投屏看大片，加载很快不卡顿，观影体验不输付费平台。',
    time: '2周前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-3">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            观众热评
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            听听影迷朋友们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((c, idx) => (
            <div
              key={idx}
              className="relative p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-accent-500/20 transition-all duration-300"
            >
              <div className="text-accent-400/30 text-3xl leading-none mb-2 font-heading">
                &ldquo;
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {c.text}
              </p>
              <div className="mt-4 pt-3 border-t border-background-200/40 flex items-center justify-between">
                <span className="text-xs font-medium text-foreground-800">
                  {c.name}
                </span>
                <span className="text-xs text-foreground-400">{c.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}